module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("5 Minutes With Jesus: Quiet Time for Your Soul")]), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "sec-3"
    }
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-6-1a.jpg",
      "src": "images/himg-6-1a.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "pz3-1"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/contents#ba_01",
      "id": "ab_01"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pAPf"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("E")]), _vm._v("ach year in amusement parks all over the world, thousands of us line up to ride the most gravity-defying, adrenaline-inducing thrill rides we can find. Giddily, we wait in line for our turn and then, at last, buckle up for the ride. Few of us pay attention to the bored sixteen-year-old at the control panel—even though he’s the one with access to the large red emergency stop button, the last safeguard in the rare event that the ride goes too fast, spins a little too wildly"), _c('i', [_vm._v(",")]), _vm._v(" and hurtles out of control.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz3-3"
    }
  }, [_vm._v("Have you ever wished you had a stop button for your life?")]), _vm._v(" "), _c('p', [_vm._v("I sure have. Some days my life feels like a thrill ride that has slipped past fun and into the realm of chaos. It’s an easy place to be in our modern world. Gone are simpler, quieter days when evenings were spent visiting with neighbors on the front porch or with family around the dinner table. Now blinking screens and beeping notifications have been "), _c('span', {
    attrs: {
      "id": "z4-2"
    }
  }, [_vm._v("added to the menu of never-ending entertainment options able to fill every waking moment of the daylight hours and even jar us from our sleep at night. ")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz4-3"
    }
  }, [_vm._v("As if that were not all exhausting enough, if you’re like me, you sometimes feel as if you never, ever stop running from one activity to another.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz4-4"
    }
  }, [_vm._v("Is it any wonder we are anxious and deeply weary? We simply were not made to live like this—running full-tilt, dashing through one adrenaline-fueled day to another against a soundtrack created by phone calls, e-mails, texts, computers, TV, radio, and even on occasion, in-person human voices.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz4-5"
    }
  }, [_vm._v("Isn’t it time we hit the emergency stop button even for just a few minutes?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz4-6"
    }
  }, [_vm._v("Well, friend, this is the invitation I am offering you today: the chance to step off the thrill ride of life and into the arms of your loving Savior. He waits to lead you beside still waters that will refresh your soul and to green pastures where you will find rest (Psalm 23).")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz4-7"
    }
  }, [_vm._v("God loves you. He never intended for you to live a frenzied, exhausting life. Listen to the words of Psalm 127:2: “It’s useless to rise early and go to bed late, and work your "), _c('span', {
    attrs: {
      "id": "z5-1"
    }
  }, [_vm._v("worried fingers to the bone. Don’t you know he enjoys giving rest to those he loves?” ("), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THE MESSAGE")]), _vm._v("). ")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz5-2"
    }
  }, [_vm._v("Jesus longs to give you the gift of rest, and it can begin with five minutes a day . . .")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz5-3"
    }
  }, [_vm._v("Five minutes to shut out the noise . . .")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz5-4"
    }
  }, [_vm._v("Five minutes to find peace in the midst of a troubled world . . .")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz5-5"
    }
  }, [_vm._v("Five minutes to step out of the crosshairs of a culture that constantly demands more, more, and more . . .")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz5-6"
    }
  }, [_vm._v("Five minutes to receive God’s sweet rest for your soul.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz5-7"
    }
  }, [_vm._v("What do you say?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz5-8"
    }
  }, [_vm._v("If you could use a little support along the way, come join the community we’ve been building at 5MinuteswithJesus.com, where you can find encouraging videos, images to share, and other reminders that just five minutes a day can transform our lives. We’d love to have you join us as we help each other keep turning to Jesus every day.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz5-9"
    }
  }, [_vm._v("Are you "), _c('span', {
    attrs: {
      "id": "pz6-1"
    }
  }, [_vm._v("ready")]), _vm._v(" to hit that stop button?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b81c7272","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 69
// module chunks = 0